import { render, staticRenderFns } from "./HotpVideo.vue?vue&type=template&id=f395c556&scoped=true"
import script from "./HotpVideo.vue?vue&type=script&lang=js"
export * from "./HotpVideo.vue?vue&type=script&lang=js"
import style0 from "./HotpVideo.vue?vue&type=style&index=0&id=f395c556&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f395c556",
  null
  
)

export default component.exports